import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: true
})
export class TruncatePipe implements PipeTransform {

	transform(value: string, maxChars: number): string {
		if (!value) return '';
		return value.slice(0, maxChars - 3) + '...';
	}
}
